import React from 'react';
import { CircleCheckIcon } from 'lucide-react';
import { SectionCta } from '../SectionCta';
import { volumeSix, volumes } from '../../data/content';
function ItemList({
  items,
  dark = false
}: {
  items: string[];
  dark?: boolean;
}) {
  return <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-277" data-mp="2wzgoezzufs2k">
      {items.map(item => <li key={item} className={`flex items-start gap-2 text-[15px] leading-snug ${dark ? 'text-white' : 'text-ink'}`} data-id="element-278" data-mp="2sywt81ytyyj2">
          <CircleCheckIcon className={`mt-0.5 h-4 w-4 shrink-0 ${dark ? 'text-gold' : 'text-success'}`} aria-hidden="true" data-id="element-279" data-mp="2o2ofmt0a7de0" />
          {item}
        </li>)}
    </ul>;
}
export function Volumes() {
  return <section className="bg-white px-4 py-16 sm:py-20" aria-labelledby="volumes-title" data-id="element-280" data-mp="29bpbpvae5d0r">
      <div className="mx-auto max-w-4xl" data-id="element-281" data-mp="299uoubfk7au1">
        <h2 id="volumes-title" className="text-center font-serif text-[32px] font-black leading-tight text-ink sm:text-5xl" data-id="element-282" data-mp="25adjrj41ofpe">
          What’s inside <span className="bg-[linear-gradient(transparent_58%,#FFC700_58%)] px-1" data-id="element-283" data-mp="20bsrc5v1b0bi">Picking Control 30™</span>?
        </h2>

        <div className="mt-12 space-y-5" data-id="element-284" data-mp="333t8zy0fk5fo">
          {volumes.map(v => <article key={v.number} className="overflow-hidden rounded-3xl border border-ink/10 bg-cream" data-id="element-285" data-mp="37xno0o53bw8f">
              <div className="flex items-center gap-4 bg-ink px-5 py-4 sm:px-7" data-id="element-286" data-mp="2u2v297ylxjte">
                <span className="flex h-12 min-w-[3rem] shrink-0 items-center justify-center rounded-xl bg-gold px-2 font-serif text-xl font-black text-ink" data-id="element-287" data-mp="2y72u3e0d3fvu">
                  {v.number}
                </span>
                <div data-id="element-288" data-mp="3qt4bbjxfi7vx">
                  <p className="text-xs font-bold uppercase tracking-wider text-gold" data-id="element-289" data-mp="3cvfoi6jswqo8">Volume {v.number}</p>
                  <h3 className="font-serif text-xl font-black leading-tight text-white sm:text-2xl" data-id="element-290" data-mp="3hua5r424e768">{v.title}</h3>
                </div>
              </div>
              <div className="p-5 sm:p-7" data-id="element-291" data-mp="21ephil7jzutk">
                <p className="text-[16px] leading-relaxed text-ink/80" data-id="element-292" data-mp="26f3pk395n4rl">{v.intro}</p>
                <p className="mt-5 text-sm font-bold uppercase tracking-wider text-ink" data-id="element-293" data-mp="26d0rcvxum5bs">Inside you’ll find:</p>
                <ItemList items={v.items} data-id="element-294" data-mp="70bvfkjdu23v" />
              </div>
            </article>)}

          <article className="overflow-hidden rounded-3xl bg-ink ring-4 ring-gold" data-id="element-295" data-mp="29bw68msj7y7">
            <div className="flex items-center gap-4 bg-gold px-5 py-4 sm:px-7" data-id="element-296" data-mp="26z95h26e7ea">
              <span className="flex h-12 min-w-[3rem] shrink-0 items-center justify-center rounded-xl bg-ink px-2 font-serif text-xl font-black text-gold" data-id="element-297" data-mp="3ucw4booyzp11">
                {volumeSix.number}
              </span>
              <div data-id="element-298" data-mp="3kh1cc2yuwhll">
                <p className="text-xs font-bold uppercase tracking-wider text-ink/80" data-id="element-299" data-mp="3ffltmhk5in6d">Volume VI · The core</p>
                <h3 className="font-serif text-xl font-black leading-tight text-ink sm:text-2xl" data-id="element-300" data-mp="3bes4jkuz32bw">{volumeSix.title}</h3>
              </div>
            </div>
            <div className="p-5 sm:p-7" data-id="element-301" data-mp="1dnpg52efb38y">
              <p className="text-[16px] leading-relaxed text-white/85" data-id="element-302" data-mp="19mdqiwvjui0r">{volumeSix.intro}</p>
              <ol className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-303" data-mp="2rks5fkpvbpcp">
                {volumeSix.weeks.map(w => <li key={w.week} className="rounded-2xl bg-ink-soft p-4 ring-1 ring-ink-line" data-id="element-304" data-mp="2wilb8cn9ehcg">
                    <p className="text-xs font-bold uppercase tracking-wider text-white/60" data-id="element-305" data-mp="31begd1mn3rp2">{w.week}</p>
                    <p className="mt-1 font-serif text-2xl font-black text-gold" data-id="element-306" data-mp="35avo61pjh0xe">{w.name}</p>
                    <p className="mt-1 text-[15px] leading-snug text-white/85" data-id="element-307" data-mp="28mft5q3ntzcw">{w.text}</p>
                  </li>)}
              </ol>
              <p className="mt-6 text-sm font-bold uppercase tracking-wider text-white" data-id="element-308" data-mp="2dmvastuz5t0o">Inside you’ll find:</p>
              <ItemList items={volumeSix.items} dark data-id="element-309" data-mp="2mlfkx6mgyuda" />
            </div>
          </article>
        </div>

        <SectionCta label="I want all 6 volumes today" data-id="element-310" data-mp="3t1j8xnkjzl1d" />
      </div>
    </section>;
}